<script setup>
import { storeToRefs } from 'pinia';
import { useNotificationsStore } from '@/store/notificationsStore';
import BaseToast from '@/components/BaseComponents/BaseToast.vue';

// Host-komponent for BaseToast. Leser notificationsStore og fôrer
// notifications-listen videre som prop. Selve BaseToast er en ren
// presentasjons-komponent — uten store-kobling — og vises overalt der
// dette host-elementet rendres.
//
// Notifikasjoner timer ut automatisk via store-en (5s setTimeout) og
// fjernes ved å sette `isActive=false` — derfor ingen dismiss-emit her.
const notificationsStore = useNotificationsStore();
const { notifications } = storeToRefs(notificationsStore);
</script>

<template>
  <BaseToast :notifications="notifications" />
</template>
